// Library Class
import { Component, OnInit, AfterViewInit, HostListener, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SOTService } from '../../../../services/seed/sot/sot.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { StockRequestHistorySliderModelService } from '../sot-request-history/sot-request-history.component-slider-model.service';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-sot-approve-reject',
  templateUrl: './sot-approve-reject.component.html',
  styleUrls: ['./sot-approve-reject.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('detailExpandDelivery', [
      state('collapsedDelivery', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expandedDelivery', style({ height: '*' })),
      transition('expandedDelivery <=> collapsedDelivery', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('detailExpandDeliveryMobile', [
      state('expandedDeliveryMobile', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('collapsedDeliveryMobile', style({ height: '*' })),
      transition('collapsedDeliveryMobile <=> expandedDeliveryMobile', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class StockTransferApproveRejectComponent implements OnInit, AfterViewInit, OnDestroy {
  // Variable declaration
  freightInstruction: any = [];
  tabNode: string;
  desiredDelDate = new Date();
  // set default pickup date as T+2 for new return.
  fromDesiredPickupDate: any = new Date(this.desiredDelDate);
  fromContactName = '';
  fromContactNumber = '';
  fromCustomerPONumber = '';
  fromShippingInstructions = '';
  selectedFreightInstructionOptions: any = [];
  selectedToFreightInstructionOptions: any = [];
  deliveryAccountList: Array<any> = [];
  fromDeliveryAccount: number;
  toDeliveryAccount: number;
  toDesiredPickupDate: any = new Date(this.desiredDelDate);
  toContactName = '';
  toContactNumber = '';
  toCustomerPONumber = '';
  toShippingInstructions = '';
  toNonStockPallet: string;
  toStockPallet: string;
  toCBox: string;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cropYear: any;
  fromNonStockPallet = 0;
  fromStockPallet = 0;
  fromCBox = 0;
  fromShipToAccountItems: any;
  fromShipToDataLoading = true;
  fromShipToAccount: number;
  toShipToAccount: number;
  dateFilter: any;
  date = new Date();
  minDate = new Date();
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  errorMsgs = new Array();
  nextErrorId = 0;
  nextLotNumber: string;
  isExpanded = true;
  isExpandedDelivery = true;
  isExpandedDeliveryMobile = true;
  isPickupDateValid = true;
  isNameValid: boolean;
  isContactValid: boolean;
  isPalletValid: boolean;
  deliverToAnotherLocation = false;
  isDraftEnable = false;
  isSubmitEnable = false;
  isAddProductEnable = false;
  selectedCount = 0;
  deliveryOption = 0;
  deliveryOptionList = [
    { id: 1, value: 'ALREADY MOVED-TO ACCOUNT FREIGHT ALLOWANCE' },
    { id: 2, value: 'ALREADY MOVED-FROM ACCOUNT FREIGHT ALLOWANCE' },
    { id: 3, value: 'ALREADY MOVED-WFU EMPLOYEE' },
    { id: 4, value: 'WFU ARRANGED' }
  ];
  productItemsDataSource: any;
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  sotOriginalProductItemsDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'packageSize', 'lotNumber', 'treatment', 'productLine', 'requestedQty'];
  addProductsSubscription: any;
  filteredDataCount = 0;
  qtyCount = 0;
  productListCopy: any;
  toAccount: any = {};
  isAllProductChecked = false;
  isSearchClicked: any;
  isValidLineStatus = false;
  checkBoxCount = 0;
  showTabs = false;
  editToolKit = false;
  toAccountName = false;
  productSearchFilter: string;
  filterValueList: any = [];
  productFilters: any;
  searchValue = '';
  partialSearchValue = '';
  productList: any[];
  /* productSearchFilter: string;*/
  filterInvoicedProductitems: any[] = [];
  marketingBrandMasterList: any[];
  packageSizeMasterList: any = [];
  treatmentMasterList: any[];
  invoicedProductList: any = [];
  productLineList: any = [];
  sotRequestId: number;
  orderNumber: string;
  sub: any;
  errorMessage = '';
  currentErrorRow = 1;
  showErrorBlock = false;
  index: any;
  isSubmit = false;
  requestStatus: string;
  rejectionReason: string;
  pickupBindDate: string;
  nextTwoDays = 172800000;
  subscription = new Subscription();

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router,
    private stockRequestHistorySliderModelService: StockRequestHistorySliderModelService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private configService: ConfigService,
    private broadcastService: BroadcastService,
    private stockTransferService: SOTService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private sotService: SOTService,
    private datePipe: DatePipe,
    private matDialog: MatDialog
  ) {
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.cropYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.getFreightList();
    this.productItemsDataSource = new MatTableDataSource([]);
    this.sotOriginalProductItemsDataSource = this.productItemsDataSource.data;

    this.subscription.add(this.activatedRoute.params.subscribe(x => {
      this.sotRequestId = +x['sotRequestId'];
      this.isSubmit = +x['isSubmit'] == 1 ? true : false;
      this.getOrderDetails();
    }));
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    if (window.innerWidth > 767) {
      const tableHeight = window.innerHeight - 85;
      $('.requestCOIOuter').css('height', tableHeight + 'px');
    }
    // else {
    //  const tableHeight = window.innerHeight - 15;
    //  $('.requestCOIOuter').css('height', tableHeight + 'px');
    // }
  }

  openRequestHistorySlider() {
    this.stockRequestHistorySliderModelService.sotRequestId = this.sotRequestId;
    this.stockRequestHistorySliderModelService.activeSlider('SOTRequestHistorySlider');
  }

  // Toggle Pickup Section
  togglePickup() {
    if (this.isSubmit) { this.isExpanded = !this.isExpanded; }
  }

  togglePickupDelivery() {
    if (!this.isSubmit) { this.isExpandedDelivery = !this.isExpandedDelivery; }
  }

  toggleDeliveryMobile() {
    this.isExpandedDeliveryMobile = !this.isExpandedDeliveryMobile;
  }
  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Formate Data from Add Product Slider Model
  formatNewAddedData(productList: any[]) {
    const orderList = [];
    this.filteredDataCount = 0;
    // this.qtyCount = 0;
    // this.totalPrice = 0;
    let rowId = 0;
    this.productItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });
    productList.forEach(x => {
      rowId = rowId + 1;
      let duplicateData = orderList.find(y => y.itemId == x.itemId && y.orderUOM == x.orderUOM && y.lotNumber == x.lotNumber);
      if (duplicateData) {
        const index = orderList.indexOf(duplicateData);
        if (index !== -1) {
          orderList.splice(index, 1);
        }
        duplicateData = orderList.find(y => y.itemId == x.itemId && y.orderUOM == x.orderUOM);
      }

      if (duplicateData == undefined) {
        const newRow = {
          rowId: rowId,
          isSelected: false,
          isProductDetailDisplayed: false,
          itemId: x.itemId,
          itemNumber: x.itemNumber,
          itemDescription: x.itemDescription,
          itemVendorName: x.itemVendorName,
          packageSize: x.packageSize,
          productLine: x.productLine,
          treatment: x.treatment,
          isParent: x.isParent,
          orderUOM: x.orderUOM,
          lotNumber: x.lotNumber,
          availableQuantity: x.availableQuantity,
          conversionFactor: x.conversionFactor ?? 1,
          requestedQty: x.requestedQty ?? 0,
          lineErrors: { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'orderUOM': x.orderUOM, 'errors': [] },
          lineError: false
        };

        this.qtyCount = this.qtyCount + x.orderQty;
        orderList.splice(orderList.length, 0, newRow);
        this.productListCopy = JSON.parse(JSON.stringify(orderList));
      }
    });

    this.filteredDataCount = orderList.length;
    this.productItemsDataSource.data = orderList;
    this.sotOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
  }

  desiredPickupDateValid(pickupDate: AbstractControl) {
    if (pickupDate.valid && pickupDate['model'] >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  validateSelectedDesiredPickupDate(event) {
    if (event.value && event.value >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  countShouldBeValid(count: AbstractControl) {
    if (count.valid) {
      this.isPalletValid = true;
    } else {
      this.isPalletValid = false;
    }
  }

  phoneShouldBeValid(phone: AbstractControl) {
    if (phone.valid) {
      this.isContactValid = true;
    } else {
      this.isContactValid = false;
    }
  }

  nameShouldBeValid(name: AbstractControl) {
    if (name.valid) {
      this.isNameValid = true;
    } else {
      this.isNameValid = false;
    }
  }

  updateDeliverToSelection(isDeliverToOptionChecked) {
    if (!isDeliverToOptionChecked) {
      this.toDeliveryAccount = null;
    }
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate;
    };
  }

  getFreightList() {
    if (this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST)) {
      this.freightInstruction = JSON.parse(this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST));
    }
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.stockTransferService.getSOTEditOrderDetail(this.sotRequestId).subscribe((result: any) => {
      this.orderNumber = result.sotrequestNumber;
      this.fromShipToAccount = result.fromAccount;
      this.fromDeliveryAccount = result.fromPickupLocation;
      this.fromCustomerPONumber = result.fromCustPonumber;
      this.fromShippingInstructions = result.fromHeaderText;
      this.fromShipToAccountItems = result.fromAccountDetail;

      this.fromContactName = result.fromContactName;
      this.fromContactNumber = result.fromContactNumber;
      this.selectedFreightInstructionOptions = result.fromFreightInstructions != null ? this.freightInstruction.filter(x => result.fromFreightInstructions.indexOf(x.id) > -1) : [];
      this.fromStockPallet = result.fromStockPalletCount;
      this.fromCBox = result.fromCBoxCount;
      this.fromNonStockPallet = result.fromNonStockPalletCount;
      this.toShipToAccount = result.toAccount;
      this.toAccount = result.toAccountDetail;

      this.deliveryOption = result.deliveryOptions;
      this.formatNewAddedData(result.sotProductList);
      this.toContactName = result.toContactName;
      this.toContactNumber = result.toContactNumber;
      this.toCustomerPONumber = result.toCustPonumber;
      this.toDeliveryAccount = result.toDeliveryLocation;
      this.toShippingInstructions = result.toHeaderText;
      this.toNonStockPallet = result.fromNonStockPalletCount;
      this.toStockPallet = result.fromStockPalletCount;
      this.toCBox = result.fromCBoxCount;
      this.selectedToFreightInstructionOptions = result.toFreightInstructions != null ? this.freightInstruction.filter(x => result.toFreightInstructions.indexOf(x.id) > -1) : [];
      this.requestStatus = result.requestStatus;
      this.toAccountName = true;
      this.isExpanded = this.isSubmit ? false : true;
      this.isExpandedDelivery = !this.isSubmit ? false : true;
      this.rejectionReason = result.rejectionComment;
      const currentDate = new Date();
      this.toDesiredPickupDate = result.toRequestDate ? result.toRequestDate : new Date(currentDate.getTime() + this.nextTwoDays);
      this.fromDesiredPickupDate = this.datePipe.transform(result.fromRequestDate, 'MM/dd/yyyy');
      this.deliverToAnotherLocation = this.toDeliveryAccount && this.toDeliveryAccount > 0 ? true : false;
      const account = !this.isExpanded ? this.fromShipToAccount : !this.isExpandedDelivery ? this.toShipToAccount : 0;
      const parentAccount = !this.isExpanded ? this.fromShipToAccountItems.parentNumber : !this.isExpandedDelivery ? this.toAccount.parentNumber : 0;

      if (this.isSubmit) {
        this.displayedColumns = ['checkbox', 'product', 'packageSize', 'lotNumber', 'treatment', 'productLine', 'availability', 'requestedQty'];
      }

      this.subscription.add(this.stockTransferService.getDeliverToLocationList(account, parentAccount)
        .subscribe((result: any[]) => {
          this.deliveryAccountList = result;
          this.deliverToAnotherLocation = this.toDeliveryAccount && this.toDeliveryAccount > 0 ? true : false;
        }, error => this.loaderService.setLoaderStatus(false))
      );

      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // Navigate To Landing Page
  navigateToLandingPage() {
    this.router.navigate(['/sot-landing']);
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.itemId == this.nextErrorId && x.lotNumber == this.nextLotNumber) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = this.index + 1;
      $('#returnRequestView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#returnRequestView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = 1;
      $('#returnRequestView').scrollTop = 0;
      $('#returnRequestView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.sotOriginalProductItemsDataSource.length > 0 && this.productItemsDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.sotOriginalProductItemsDataSource.filter(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber && x.orderUOM === element.orderUOM)[0];
        oldLineValue.lineErrors = { 'itemId': oldLineValue.itemId, 'lotNumber': oldLineValue.lotNumber, 'orderUOM': oldLineValue.orderUOM, 'errors': [] };;

        // get current object index
        const currentLineIndex = this.productItemsDataSource.data.findIndex(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber && x.orderUOM === element.orderUOM);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.productItemsDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.productItemsDataSource.data = this.productItemsDataSource.data;
          const index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === oldLineValue.itemId && element.lotNumber === oldLineValue.lotNumber;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.itemId, oldLineValue.lotNumber);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.productItemsDataSource.data = JSON.parse(JSON.stringify(this.sotOriginalProductItemsDataSource));
        this.productItemsDataSource.data.forEach(x => {
          x.eligibleUnit = x.isManualLine ? 0 : ((x.invoiceUnits && x.totalReturnUnits) ? (x.invoiceUnits - x.totalReturnUnits) : x.eligibleUnit);
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'orderUOM': x.orderUOM, 'errors': [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.showTabs = false;
      this.isSearchClicked = true;
      this.editToolKit = false;
      this.isSubmitEnable = true;
      this.isDraftEnable = true;
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true, labelNo: 'No, go back to Request' });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide and show error line error
  showHideLineError(errorId: number, lotNumber: string) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString() + '_' + lotNumber);
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.checkBoxCount = 0;
    this.showTabs = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.isAllProductChecked = false;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  createNewOrder() {
    this.router.navigate(['/sot-request-entry']);
  }

  openRejectDialog() {
    if (this.validateOrder()) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '650px',
        data: { dialogType: 'sotRequestReject', title: 'Rejection Reasons' }
      });

      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.rejectionReason = result.comments;
          this.saveRequest(result.status, result.comments);
        }
      }));
    }
  }

  saveRequest(requestStatus: string, comment: string = null) {
    if (this.validateOrder()) {
      $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');
      const saveObj: any = {};

      this.loaderService.setLoaderStatus(true);
      if (requestStatus == 'EDITING') {
        saveObj.sotrequestId = this.sotRequestId;
        saveObj.requestStatus = requestStatus;

        this.subscription.add(this.stockTransferService.sotUpdateRequestStatus(saveObj).subscribe((result: any) => {
          if (result) {
            this.requestStatus = requestStatus;
            this.sotService.setSOTRequestId(+this.sotRequestId);
            this.router.navigate(['/sot-request-entry']);

            this.loaderService.setLoaderStatus(false);
          }
        }, (error) => {
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('Request not saved in the system.');
        }));
      }
      else {
        saveObj.companyCode = this.headerCompany;
        saveObj.fromAccount = this.fromShipToAccount;
        saveObj.toAccount = this.toShipToAccount;
        saveObj.toDeliveryLocation = this.toDeliveryAccount;
        saveObj.toRequestDate = (new Date(this.toDesiredPickupDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
        saveObj.toCustPonumber = this.toCustomerPONumber;
        saveObj.toHeaderText = this.toShippingInstructions;
        if ((this.toShippingInstructions && (this.toShippingInstructions != ''))) {
          saveObj.toSpecialInstCode = 41;
        }
        saveObj.toContactName = this.toContactName;
        saveObj.toContactNumber = this.toContactNumber;
        saveObj.toFreightInstructions = this.selectedToFreightInstructionOptions.map(x => x.id).join();
        saveObj.toStockPalletCount = this.toStockPallet;
        saveObj.toNonStockPalletCount = this.toNonStockPallet;
        saveObj.toCBoxCount = this.toCBox;
        saveObj.requestStatus = requestStatus;
        saveObj.isUpdateRequest = true;
        saveObj.sotrequestId = this.sotRequestId;
        saveObj.rejectionComment = comment;
        saveObj.fromToRequest = 'TO';

        this.subscription.add(this.stockTransferService.saveOrder(saveObj).subscribe((result: any) => {
          if (result) {
            if (result.errors.length > 0) {
              this.loaderService.setLoaderStatus(false);
              result.errors.forEach(x => {
                this.toastrService.error(x);
                return false;
              });
            } else {
              this.requestStatus = requestStatus;
              this.toCustomerPONumber = result.toCustPonumber;
              let successMsg = 'Order #' + result.sotrequestNumber + ' ' + requestStatus.toLowerCase() + ' successfully.';
              if (requestStatus.toLowerCase() == 'approved' && result.sotrequestNumber == null) {
                successMsg = ' Order has already been approved. ';
              }

              this.toastrService.success(successMsg);
              this.loaderService.setLoaderStatus(false);
            }
          }
        }, (error) => {
          this.loaderService.setLoaderStatus(false);
          this.toastrService.error('Request not saved in the system.');
        }));
      }
    }
  }

  validateOrder() {
    let isValidated = true;
    this.errorMsgs = new Array();
    const contactName = !this.isExpanded ? this.fromContactName : !this.isExpandedDelivery ? this.toContactName : this.fromContactName;
    const contactNo = !this.isExpanded ? this.fromContactNumber : !this.isExpandedDelivery ? this.toContactNumber : this.fromContactNumber;
    if (this.deliveryOption == 4 && (!contactName)) {
      isValidated = false;
      this.toastrService.error('Please enter a contact name.');
    } else if (this.deliveryOption == 4 && (contactNo == undefined || contactNo.length < 10)) {
      isValidated = false;
      this.toastrService.error('Please enter a 10 digit phone number.');
    }
    return isValidated;
  }

  // Generate PDF
  generatedPdf(sotRequestId: any) {
    if (sotRequestId) {
      this.stockTransferService.generatePdf(sotRequestId,this.isMobile);
    }
  }

  emailOrderDetail(sotRequestId: any) {
    let emailId = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        emailId = data.resultData[0].emailId;
      }
    }
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { email: emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' }
    });

    this.subscription.add(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          SOTRequestId: sotRequestId,
          EmailIds: emailIds
        };
        this.loaderService.setLoaderStatus(true);

        this.subscription.add(this.sotService.sendSOTRequestEmail(data).subscribe(result => {
          if (result) { this.loaderService.setLoaderStatus(false); }
          this.toastrService.success('Email sent');
        }));
      }
    }));
  }

  isHeaderButtonsEnable() {
    if (this.requestStatus == 'SUBMITTED' || this.requestStatus == 'EDITING' || this.requestStatus == 'APPROVED' || this.requestStatus == 'REJECTED' || this.requestStatus == 'COMPLETED' || this.requestStatus == 'CANCELLED') { return true; }
    else { return false; }
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
